<template lang="pug">
  #block-view
    #bv-info
      #bv-title Blocked Users
    #bv-items
      h1.title(v-if="!users.length") No blocked users

      template(v-else)
        .bv-item.header
          span Full Name
          span Username
          span Location
          span Bio
          span Avatar
          span Actions

        .bv-item(v-for="user in users" :key="user.id" )
          span: RouterLink(:to="{name: 'peopleShow', params: { slug: user.username }}") {{ user.fullName }}
          span {{ user.username }}
          span {{ user.location }}
          span {{ user.bio }}
          span: img(:src="user.image")
          span.center: button.button(@click="unblock(user)") Unblock
</template>

<script>
import User from '@/models/user'

export default {
  props: {},

  data() {
    return {
      users: [],
    }
  },

  computed: {
    avatar,
  },

  watch: {},

  async mounted() {
    const response = await this.$store.dispatch('currentUser/fetchBlockUsers')
    this.users = response.map(u => new User(u))
  },

  methods: {
    unblock,
  },

  components: {},
}

/* Computed ---------------------------------------------------- */
function avatar() {
  const defaultImage = require('@/assets/images/avatar.png')
  return defaultImage
}
/* Watch ------------------------------------------------------- */
/* Methods ----------------------------------------------------- */
async function unblock(user) {
  const response = await this.$store.dispatch('currentUser/unblock', user.id)
  console.log('BlockView.vue :63', response)
  if (response) {
    this.$notyf.success(`Unblocked user ${user.fullName}`)

    const index = this.users.findIndex(u => u.id == user.id)

    if (index !== -1) {
      this.users.splice(index, 1)
    }
  }
}
</script>
